export const authColSpan = {
  span: 24,
  sm: 18,
  md: 12,
  lg: 10,
  xl: 8,
}
